import { useEffect } from "react";
import { PageTitleHeader } from "@UI/PageTitleHeader/PageTitleHeader";
import styles from "./PageContent.module.css";

const SCROLL_CONTAINER_ID = "page-scroll-container";

export const PageContent = ({
  children,
  scrollKey,
  title,
  breadcrumb,
  actions,
  titleAccessory,
  nested,
  disablePageScroll,
}) => {
  useEffect(() => {
    const container = document.getElementById(SCROLL_CONTAINER_ID);
    if (container && scrollKey !== undefined) {
      container.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [scrollKey]);

  return (
    <div
      className={nested ? `${styles.pageContent} ${styles.pageContentNested}` : styles.pageContent}
      id={SCROLL_CONTAINER_ID}
      {...(disablePageScroll ? { "data-no-page-scroll": "true" } : {})}
    >
      {(title != null && title !== "") || (Array.isArray(breadcrumb) && breadcrumb.length > 0) ? (
        <PageTitleHeader
          title={title}
          breadcrumb={breadcrumb}
          actions={actions}
          titleAccessory={titleAccessory}
        />
      ) : null}
      {children}
    </div>
  );
};
